import React from 'react'
import "./Contacts.scss"
import { motion } from "framer-motion";

const contactMe = () => {
    const email = 'dench327@gmail.com';
    const subject = 'Nice to meet you!';
    const body = 'Hi, I want to get in touch with you.';

    const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoUrl;
};

export const Contacts = () => {

  return (
    <div className='contact flex container'>
      <motion.h1
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="title">
            Interested in working with me?
        </motion.h1>
        <motion.div
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="btn-container">
            <button className='get-in-touch-btn' onClick={contactMe}>GET IN TOUCH</button>
        </motion.div>
    </div>
  )
}